import React from "react";
import {
  MapContainer,
  TileLayer,
  LayersControl,
  Marker,
  Popup,
} from "react-leaflet";
import { ZoneOverlays } from "../../../util/zoneOverlays";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import fleetIcon from "../../../assets/flaticons/cargo-ship.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

// Create custom icon for vessels
const vesselIcon = new L.Icon({
  iconUrl: fleetIcon,
  shadowUrl: markerShadow,
  shadowSize: [41, 25],
  iconSize: [25, 25],
  iconAnchor: [10, 18],
  popupAnchor: [0, -5],
});

const tileLayers = {
  worldStreet: {
    name: "World Street Map",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}",
    attribution: "Esri",
  },
  seaMark: {
    name: "Sea Mark",
    url: "http://t1.openseamap.org/seamark/{z}/{x}/{y}.png",
    attribution: "OpenSeaMap",
  },
  osm: {
    name: "OpenStreetMap",
    url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
    attribution: "OpenStreetMap contributors",
  },
  worldImagery: {
    name: "World Imagery",
    url: "http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    attribution: "Esri",
  },
  worldGrayCanvas: {
    name: "World Gray Canvas",
    url: "http://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}",
    attribution: "Esri",
  },
  blackAndWhite: {
    name: "Black and White",
    url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png",
    attribution: "OpenStreetMap contributors",
  },
};
const LiveVesselLocation = ({ vesselList }) => {
  return (
    <div className="flex h-full">
      {/* Map Container */}
      <div className="flex-1 h-full">
        <MapContainer
          center={[0, 0]}
          zoom={2}
          style={{ height: "100%", width: "100%" }}
        >
          <LayersControl position="topright">
            <LayersControl.BaseLayer name={tileLayers.worldImagery.name}>
              <TileLayer
                attribution={tileLayers.worldImagery.attribution}
                url={tileLayers.worldImagery.url}
              />
            </LayersControl.BaseLayer>

            <LayersControl.BaseLayer checked name={tileLayers.worldStreet.name}>
              <TileLayer
                attribution={tileLayers.worldStreet.attribution}
                url={tileLayers.worldStreet.url}
              />
            </LayersControl.BaseLayer>

            <LayersControl.BaseLayer name={tileLayers.osm.name}>
              <TileLayer
                attribution={tileLayers.osm.attribution}
                url={tileLayers.osm.url}
              />
            </LayersControl.BaseLayer>

            <LayersControl.BaseLayer name={tileLayers.worldGrayCanvas.name}>
              <TileLayer
                attribution={tileLayers.worldGrayCanvas.attribution}
                url={tileLayers.worldGrayCanvas.url}
              />
            </LayersControl.BaseLayer>

            <LayersControl.BaseLayer name={tileLayers.blackAndWhite.name}>
              <TileLayer
                attribution={tileLayers.blackAndWhite.attribution}
                url={tileLayers.blackAndWhite.url}
              />
            </LayersControl.BaseLayer>
          <ZoneOverlays />
          </LayersControl>

          {/* Vessel Markers */}
          {vesselList &&
            vesselList.map((vessel) => (
              <Marker
                key={vessel._id}
                position={[vessel.lat, vessel.lng]}
                icon={vesselIcon}
              >
                <Popup>
                  <div>
                    <h3 className="font-bold">{vessel.name}</h3>
                    <p>MMSI: {vessel.mmsi}</p>
                    {vessel.imo && <p>IMO: {vessel.imo}</p>}
                    <p>
                      Position: {vessel.lat.toFixed(5)}, {vessel.lng.toFixed(5)}
                    </p>
                    <p>
                      Last updated:{" "}
                      {new Date(vessel.updatedAt).toLocaleString()}
                    </p>
                    <p>Size: {vessel.size || "-"}</p>
                    <p>Width: {vessel.width || "-"}</p>
                    <p>Hight: {vessel.hight || "-"}</p>
                    <p>Dead Weight: {vessel.deadWeight || "-"}</p>
                  </div>
                </Popup>
              </Marker>
            ))}
        </MapContainer>
      </div>
    </div>
  );
};

export default LiveVesselLocation;
